// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.border_syle_staff {
  border: 1px solid #DCDCDC;
  background-color: white;
  border-radius: 8px;
}

.img_staff_detail_set {
  height: 90px;
  width: 90px;
  object-fit: cover;
}

.heading_staff {
  color: #000;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.sub_heading_staff {
  color: #808080;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.sub1_heading_staff {
  color: #B1B4B7;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.main_heading {
  color: #4D4D4D;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.label_first {
  color: #AAA;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  padding-bottom: 3px;
}

.text_of_label {
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.text_of_label_if_notadded {
  color: #6C6C6C;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.background_of_line {
  background-color: #F0F0F0;
  border: 1px solid #F0F0F0;
}

.icons_size {
  width: 16px;
}

.icons_size1 {
  width: 14px;
}

.margintop_neg {
  margin-top: -23px;
  padding-right: 10px;
}

.font_color_line {
  color: #AAA;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Dashboard/MainComponent/Stafflistview/staffview.scss"],"names":[],"mappings":"AAAA;EAEI,yBAAA;EACA,uBAAA;EACA,kBAAA;AAAJ;;AAGA;EAEI,YAAA;EACA,WAAA;EACA,iBAAA;AADJ;;AAGA;EAEI,WAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;;AAIA;EAEI,cAAA;EACJ,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFA;;AAKA;EAEI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;;AAMA;EAEI,cAAA;EACJ,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAJA;;AAOA;EAEI,WAAA;EACJ,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AALA;;AAQA;EAEI,WAAA;EACJ,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AANA;;AAQA;EAEI,cAAA;EACJ,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AANA;;AAQA;EAEI,yBAAA;EACA,yBAAA;AANJ;;AASA;EAEI,WAAA;AAPJ;;AAUA;EAEI,WAAA;AARJ;;AAWA;EAEI,iBAAA;EACA,mBAAA;AATJ;;AAYA;EAEI,WAAA;AAVJ","sourcesContent":[".border_syle_staff\n{\n    border: 1px solid #DCDCDC;\n    background-color: white;\n    border-radius: 8px;\n}\n\n.img_staff_detail_set\n{\n    height: 90px;\n    width: 90px;\n    object-fit: cover;\n}\n.heading_staff\n{\n    color: #000;\n    font-family: 'Inter', sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.sub_heading_staff\n{\n    color: #808080;\nfont-family: 'Inter', sans-serif;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n}\n\n.sub1_heading_staff\n{\n    color: #B1B4B7;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.main_heading\n{\n    color: #4D4D4D;\nfont-family: Roboto;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\n}\n\n.label_first\n{\n    color: #AAA;\nfont-family: Roboto;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 400;\npadding-bottom: 3px;\n}\n\n.text_of_label\n{\n    color: #000;\nfont-family: Roboto;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 400;\n}\n.text_of_label_if_notadded\n{\n    color: #6C6C6C;\nfont-family: Roboto;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n}\n.background_of_line\n{\n    background-color: #F0F0F0;\n    border: 1px solid #F0F0F0;\n}\n\n.icons_size\n{\n    width: 16px;\n}\n\n.icons_size1\n{\n    width: 14px;\n}\n\n.margintop_neg\n{\n    margin-top: -23px;\n    padding-right: 10px;\n}\n\n.font_color_line\n{\n    color: #AAA;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
